import { render, staticRenderFns } from "./GuestToAccount.vue?vue&type=template&id=1b72845b&"
import script from "./GuestToAccount.vue?vue&type=script&lang=js&"
export * from "./GuestToAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b72845b')) {
      api.createRecord('1b72845b', component.options)
    } else {
      api.reload('1b72845b', component.options)
    }
    module.hot.accept("./GuestToAccount.vue?vue&type=template&id=1b72845b&", function () {
      api.rerender('1b72845b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/GuestToAccount.vue"
export default component.exports